export const DOMAINS = {
  CERT: 'cert.gcpshore.virginvoyages.com',
  DEV: 'app.dev.virginvoyages.com',
  PROD: 'www.virginvoyages.com',
  STAGE: 'stage.gcp.virginvoyages.com',
} as const;
